import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "content", "title"]

  async open(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!this.hasDialogTarget) return

    const trigger = event.currentTarget
    const url = trigger.dataset.breakdownUrl
    if (!url) return

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = trigger.dataset.breakdownTitle || ""
    }

    this.showDialog()
    this.setContent(`<p class="text-gray-500 p-4">${this.loadingMessage}</p>`)
    this.dialogTarget.setAttribute("aria-busy", "true")

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": this.csrfToken
        },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error("Failed to load breakdown")

      this.setContent(await response.text())
    } catch (_error) {
      this.setContent(`<p class="text-red-600 p-4">${this.errorMessage}</p>`)
    } finally {
      this.dialogTarget.removeAttribute("aria-busy")
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.hasDialogTarget) return
    if (this.dialogTarget.getAttribute("aria-busy") === "true") return

    this.dialogTarget.classList.remove("opacity-100")
    setTimeout(() => this.dialogTarget.classList.add("hidden"), 200)
  }

  closeBackdrop(event) {
    if (event.target === event.currentTarget) this.close(event)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  showDialog() {
    this.dialogTarget.classList.remove("hidden")
    requestAnimationFrame(() => this.dialogTarget.classList.add("opacity-100"))
  }

  setContent(html) {
    if (this.hasContentTarget) this.contentTarget.innerHTML = html
  }

  get loadingMessage() {
    return this.element.dataset.loadingMessage || "Loading..."
  }

  get errorMessage() {
    return this.element.dataset.errorMessage || "Could not load breakdown."
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
